// store/reducers/alertReducer.js
import { createSlice } from '@reduxjs/toolkit';

const alertSlice = createSlice({
  name: 'alertList',
  initialState: {
    type: null, // 'success' | 'error' | 'warning'
    message: '',
    visible: false
  },
  reducers: {
    showAlert: (state, action) => {
      state.type = action.payload.type;
      state.message = action.payload.message;
      state.visible = true;
    },
    hideAlert: (state) => {
      state.visible = false;
      state.message = '';
      state.type = null;
    }
  }
});

export const { showAlert, hideAlert } = alertSlice.actions;
export default alertSlice.reducer;
